import { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { ORG_MODULE_ACCESS_DENIED_EVENT } from '@/lib/axios'
import { useTranslation } from 'react-i18next'
import { tokens } from '@/locales/translations/tokens'

export function OrgModuleAccessDeniedDialog() {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    const handler = () => {
      setOpen(true)
    }
    window.addEventListener(ORG_MODULE_ACCESS_DENIED_EVENT, handler)
    return () => {
      window.removeEventListener(ORG_MODULE_ACCESS_DENIED_EVENT, handler)
    }
  }, [])

  const handleConfirm = async () => {
    setOpen(false)
    const { router } = await import('@/main')
    await router.navigate({ to: '/', replace: true })
  }

  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (next) setOpen(true)
      }}
    >
      <DialogContent
        hideCloseButton
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{t(tokens.ui.moduleAccessDenied.title)}</DialogTitle>
          <DialogDescription>
            {t(tokens.ui.moduleAccessDenied.description)}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button data-confirm='true' onClick={handleConfirm}>{t(tokens.ui.moduleAccessDenied.cta)}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default OrgModuleAccessDeniedDialog
